var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('p',{staticClass:"cluster-text"},[_vm._v(_vm._s(_vm.getNumber()))])])
}
var staticRenderFns = []

export { render, staticRenderFns }